import { TableDrawer } from "@components/TableDrawer/TableDrawer";
import { useQuery } from "@hooks/useQuery";
import { decodeHTML } from "@utils/CommonUtils";
import { drilldownData, ModuleConfig } from "@utils/drilldownData";
import { Pagination, TableColumnsType, Typography } from "antd";
import { get as _get } from "lodash";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { DataTable } from "~/Components";
import ConfirmationModal from "~/Components/Modal/confirmation-modal";
import { useNotification } from "~/Hooks/useNotification";
import ActionDropdown, { TypeData } from "~/Modules/ECMS/PASSENGER/ActionDropdown";
import { magpCMSApi, post } from "~/Services";
import { magpHost } from "~/Utils";
import {
  renderActionsColumn,
  renderDateColumn,
  renderImageColumn,
  renderPublishedColumn,
} from "~/Utils/TableRenderFunction";
import { useMobileHomepageBannerSlider } from "../../Others.hook";

export const MobileHomepageBannerSlider = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();

  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [id, setId] = useState<string | undefined>(selectedRowData?.id);

  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deleteConfirmLoading, setDeleteConfirmLoading] = useState(false);

  const [searchValue, setSearchValue] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [totalRecords, setTotalRecords] = useState<number>(0);

  const [data, setData] = useState<any>([]);
  const [sortedData, setSortedData] = useState<any>([]);
  const currentPageData = sortedData.slice(currentPage * 10, (currentPage + 1) * 10);
  const [sortOrder, setSortOrder] = useState<string | undefined>();
  const [orderByName, setOrderByName] = useState<string>("id");
  const [selectedPublishedType, setselectedPublishedType] = useState<any>("");
  console.log("selectedPublishedType", selectedPublishedType);
  const publishedType: TypeData[] = [
    {
      label: "Published",
      value: true,
    },
    {
      label: "Unpublished",
      value: false,
    },
  ];

  const [reviewNotes, setReviewNotes] = useState("");
  const [reviewNotesError, setReviewNotesError] = useState(false);

  const {
    data: drilldown,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchDocument,
  } = useMobileHomepageBannerSlider(id || "");

  useEffect(() => {
    if (id) {
      refetchDocument();
    }
  }, [id]);

  useEffect(() => {
    if (query.get("subActiveTab") === "mobileHomepageBannerSlider") {
      setselectedPublishedType("");
      setSearchValue("");
      setCurrentPage(0);
    }
  }, [query.get("subActiveTab")]);

  useEffect(() => {
    let filteredData = data;

    if (searchValue) {
      filteredData = filteredData.filter((item: any) => {
        return (
          // item.field_faqs_header.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.name_en.toLowerCase().includes(searchValue.toLowerCase())
          // item.updated_at.toString().toLowerCase().includes(searchValue.toLowerCase())
        );
      });
    }
    if (selectedPublishedType !== undefined && selectedPublishedType !== "") {
      filteredData = filteredData.filter((item: any) => item.published === selectedPublishedType);
    }
    setSortedData(filteredData);
    setTotalRecords(filteredData.length);
    setCurrentPage(0);
  }, [data, searchValue, selectedPublishedType]);

  const getRecords = () => {
    setIsLoading(true);
    let url = `/api/get-mobile-banner-images/all-fields`;
    magpCMSApi
      .get(url)
      .then((res: any) => {
        if (res && res.data) {
          let envelopes = res.data;
          setTotalRecords(envelopes.length);
          setData(envelopes);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setData([]);
        setIsLoading(false);
      });
  };

  const columns: TableColumnsType = [
    {
      title: "Order Sequence",
      dataIndex: "sequence",
      key: "sequence",
      sorter: true,
      width: 60,
    },
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      sorter: true,
      width: 60,
      render: renderImageColumn,
    },
    {
      title: "Title",
      dataIndex: "name_en",
      key: "name_en",
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "name_en"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "name_en"
            ? "descend"
            : undefined,
      render: (text) => decodeHTML(text),
    },
    {
      title: "Published",
      dataIndex: "published",
      key: "published",
      width: 50,
      render: renderPublishedColumn,
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 50,
      fixed: "right",
      render: (value: any) => renderDateColumn(value),
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "createdAt"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "createdAt"
            ? "descend"
            : undefined,
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: 50,
      fixed: "right",
      render: (value: any) => renderDateColumn(value),
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "updatedAt"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "updatedAt"
            ? "descend"
            : undefined,
    },
    {
      title: "Actions",
      key: "actions",
      width: 50,
      fixed: "right",
      render: (record: any) =>
        renderActionsColumn(
          record,
          setSelectedRowData,
          setDrawerVisible,
          (e: any) => {
            e.preventDefault();
            navigate(`/dedicated/magp/others/banners/mobileHomepageBannerSlider/add?editId=${record.id}`);
          },
          undefined,
          setDeleteModalVisible,
          "faq"
        ),
    },
  ];

  useEffect(() => {
    getRecords();
  }, []);

  useEffect(() => {
    setId(selectedRowData?.id);
  }, [selectedRowData]);

  const handleTableSort = (column: any, sortOrder: string) => {
    let order = "";

    if (sortOrder === "asc") {
      setSortOrder("desc");
      order = "desc";
    } else if (sortOrder === "desc") {
      setSortOrder(undefined);
      order = undefined;
    } else if (sortOrder === undefined) {
      setSortOrder("asc");
      order = "asc";
    }

    setOrderByName(column.dataIndex);

    const tempData = [...data];
    setSortedData(tempData.sort((a: any, b: any) => handleSort(a, b, order, column.dataIndex)));
    setCurrentPage(0);
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    if (apiUrl === "") return;

    let excludedKeys: any = [];
    // for (let key in data) {
    //   if (typeof data[key] === "string" && !excludedKeys.includes(key)) {
    //     data[key] = encodeHTML(data[key]);
    //   }
    // }

    const payload = {
      action: action,
      method: method,
      module: "OTHERS",
      subModule: `banners_mobileHomepageBannerSlider`,
      type: "DEDICATED",
      application: "MAGP",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAGP",
          apiUrl: apiUrl,
        },
      ],
      payload: data,
      status: status,
    };

    post("/management/publish", payload)
      .then((response) => {
        openToast({
          content: "Data Sent for Review",
          type: "success",
        });
      })
      .catch((err: any) => {
        openToast({
          content: "Failed to send data",
          type: "error",
        });
      });
  };

  async function sendDeleteFAQRequest(reviewNotes: string) {
    try {
      await onSubmit(
        selectedRowData,
        `${magpHost}/api/get-mobile-banner-images-list-crud-api-data/${selectedRowData?.id}`,
        "DELETE",
        "DELETE",
        "PENDING",
        reviewNotes
      );
    } catch (err) {}
  }

  return (
    <>
      <DataTable
        columns={columns.map((col) => ({
          ...col,
          onHeaderCell: (column: any) => (col.sorter ? { onClick: () => handleTableSort(col, sortOrder) } : {}),
        }))}
        multiSelect={false}
        className="table-clickable"
        tableData={
          currentPageData
            ? currentPageData?.map((d: any) => {
                return {
                  ...d,
                };
              })
            : []
        }
        isLoading={isLoading}
        exportFileName="CONTRACT"
        isPagination={true}
        recordsPerPage={10}
        onSearchChange={(searchText: string) => {
          setSearchValue(searchText);
          setCurrentPage(0);
        }}
        hideExport={true}
        isServerSearchApi={false}
        searchPlaceholderText={"Search by Title"}
        onClick={(record) => {
          setSelectedRowData(record);
        }}
        additionalCTA={
          <div className="flex items-center space-x-2">
            <ActionDropdown
              value={selectedPublishedType}
              options={publishedType}
              onChange={setselectedPublishedType}
              placeholder="Select Published"
            />
          </div>
        }
      />
      <div className="pagination">
        <Pagination
          defaultCurrent={1}
          current={currentPage + 1}
          total={totalRecords}
          onChange={(curPage) => {
            setCurrentPage(curPage - 1);
          }}
          showSizeChanger={false}
        />
      </div>

      <TableDrawer
        title={
          <Typography.Title
            level={4}
            className={"!mb-0"}
          >
            Detailed View
          </Typography.Title>
        }
        visible={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        fields={drilldownData[_get(drilldown, "subModule", "mobileHomepageBannerSlider") as ModuleConfig]}
        data={drilldown?.[0]}
      />

      <ConfirmationModal
        type="delete"
        open={deleteModalVisible}
        onClose={() => setDeleteModalVisible(false)}
        onSubmit={sendDeleteFAQRequest}
      />
    </>
  );
};

function handleSort(a: any, b: any, order: string, sortBy: string) {
  if (sortBy === "name_en") {
    const numberA = extractNumber(a[sortBy]);
    const numberB = extractNumber(b[sortBy]);

    if (order === "desc") {
      return numberA < numberB ? 1 : -1;
    } else if (order === "asc") {
      return numberA > numberB ? 1 : -1;
    } else {
      return 0;
    }
  }

  if (order === "desc") {
    return a[sortBy] < b[sortBy] ? 1 : -1;
  } else if (order === "asc") {
    return a[sortBy] > b[sortBy] ? 1 : -1;
  } else {
    return 0;
  }
}

function extractNumber(question: string): number {
  const match = question.match(/Q(\d+)/);
  return match ? parseInt(match[1], 10) : 0;
}
